export default "__VITE_ASSET__CLtBD2Xl__"